export default __webpack_public_path__ + "static/media/icon-video-library.af03878b.png";